import { PaginationRequest } from '../config/common';
import { Consignment } from 'src/@core/models';

export class PaginationCustomerRequest extends PaginationRequest {
    dateRange: number = 0;
    customerName: string = '';
    year: number = 0;
    month: number = 0;
    status: number = 0;
    salesPerson: string = '';
}

export class ExportCustomerDataRequest {
    dateRange: number = 0;
    customerName: string = '';
    year: number = 0;
    month: number = 0;
    status: number = 0;
    salesPerson: string = '';
}

export interface CreateCustomerRequest {
    companyName?: string;
    businessSector?: string;
    companyRegistrationNumber?: string;
    salesPerson?: string;
    nameAppearAccount?: string;
    yearsTrading?: number;
    companyPostcode?: string;
    vatNumber?: string;
    branchContactName?: string;
    branchPhone?: string;
    branchMobile?: string;
    branchEmail?: string;
    branchAddress1?: string;
    branchAddress2?: string;
    branchAddress3?: string;
    branchTownCity?: string;
    branchCounty?: string;
    branchID?: string;
    branchPostcode?: string;
    headOfficeSameAsAbove?: boolean;
    headOfficePhone?: string;
    headOfficePostcode?: string;
    headOfficeAddress1?: string;
    headOfficeAddress2?: string;
    headOfficeAddress3?: string;
    headOfficeTownCity?: string;
    headOfficeCounty?: string;
    accountsSameAsAbove?: boolean;
    accountsContactName?: string;
    accountsPhone?: string;
    accountsEmail?: string;
    accountsPostcode?: string;
    accountsAddress1?: string;
    accountsAddress2?: string;
    accountsAddress3?: string;
    accountsTownCity?: string;
    accountsCounty?: string;
    step?: number;
    isDraft?: boolean;
    fuelSurchargeRate?: number;
    fuelSurchargeServiceTypes?: number[];
    nonVat?: boolean;
  isOnHold?: boolean;
  onHoldReason?: string;
}

export class ConsignmentOverviewRequest extends PaginationRequest {
    dateFrom?: string;
    dateTo?: string;
    customerId: string;
    driverId: string;
    branchId: string;
    haulageExchangeID?: string;
  actioned?: number = 0;
  hxquoted?: number = 0;
  invoiced?: number = 0;
  numberOfHxConsignments?: number = 0;
    delivered?: number = 0;
    consignmentType?: number = 0;
    exceptionType?: number = 0;
    serviceConsignment: number = -1;
}
export class ConsignmentOverviewDto {
    companyName: string;
    id: string;
    actioned: number;
    invoiced: number;
    numberOfConsignments: number;
    numberOfPallets: number;
    numberOfPackages: number;
    weight: string;
    ready: boolean;
    closeTime: Date;
    mainStatus: string;
    consignments: Array<Consignment>;
  serviceConsignment: number;
  isExpanded: boolean = false;
}

export interface XeroCustomer {
    step?: number,
    xeroContactID?: string,
  customerId?: string,
  paymentTerm?: string,
  creditLimit?: string,
  cutOffTime?: string,
  estimatedDailyUsage?: string
}

export class CustomerUsageSummaryDto {
    totalUnderEstimatedCustomer: number;
    totalEstimatedCustomer: number;
    totalOverEstimatedCustomer: number;
    total: number;
    constructor(underestimatedCount: number,
                estimatedCount: number,
                overestimatedCount: number,
                total: number) {
        this.totalUnderEstimatedCustomer = underestimatedCount;
        this.totalEstimatedCustomer = estimatedCount;
        this.totalOverEstimatedCustomer = overestimatedCount;
        this.total = total;
    }
}

export class CustomerStatusRequest {
    monthRange?: number = 12;
}
export class CustomerStatusDto {
    year: number;
    month: number;
    status: number;
    constructor(year: number,
        month: number,
        status: number) {
            this.year = year;
        this.month = month;
        this.status = status;
    }
}
